import { Grid, type GridProps } from '@tunasong/ui-lib'
import { capitalize } from '@tunasong/models'
import { getDefaultTemplates, type Template, type TunaPlugin } from '@tunasong/plugin-lib'
import type { FC } from 'react'
import { Fragment, useCallback } from 'react'
import TemplateCard from './template-card.js'

interface TemplatePluginsProps extends Omit<GridProps, 'onSelect'> {
  selected?: Template
  plugins: TunaPlugin[]
  onSelect: (template: Template) => void
}

/** Templates from plugin */
export const TemplatePlugins: FC<TemplatePluginsProps> = props => {
  const { selected, onSelect, plugins, ...restProps } = props

  const handleSelect = useCallback(
    (template: Template) => () => {
      onSelect(template)
    },
    [onSelect]
  )

  return (
    <Grid container spacing={2} {...restProps}>
      {plugins
        .filter(p => !Boolean(p.disallowUserCreate))
        .map(p => (
          <Fragment key={p.key}>
            {(p.templates ?? getDefaultTemplates(p)).map((template, idx) => (
              <Grid size={{ xs: 12, sm: 6, md: 4 }} key={idx}>
                <TemplateCard
                  key={idx}
                  plugin={p}
                  title={template.name ?? capitalize(p.node?.type ?? '')}
                  description={template.description ?? p.description ?? 'Template for ' + p.node?.type}
                  template={template}
                  onSelect={handleSelect(template)}
                  selected={selected?.name === template.name}
                />
              </Grid>
            ))}
          </Fragment>
        ))}
    </Grid>
  )
}

export default TemplatePlugins
